export type AverageDay = 7;

export const AVERAGEDAY = 7;
